<template>
    <div>
        <el-select
            :value="selected"
            @input="dispatch"
            :multiple="multiple"
            :placeholder="placeholder || $t('message.question_direction_list')"
            filterable
            clearable
            :collapse-tags="collapseTags"
            :size="size"
            class="d-block"
            :class="mode ? 'input__day' : 'input__night'"
        >
            <el-option
                v-for="(question_direction, index) in question_directions"
                :key="'question_directions-' + index"
                :label="question_direction.title"
                :value="question_direction.id"
            ></el-option>
        </el-select>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { i18n } from "@/utils/i18n";
export default {
    props: {
        size: {
            default: "small",
        },
        placeholder: {
            default: null,
        },
        id: {
            default: null,
        },
        multiple: {
            default: false,
        },
        collapseTags: {
            default: false,
        },
    },
    watch: {
        id: {
            handler: function (val) {
              if (val) {
                this.selected = this.id;
              }
            },
            immediate: true,
            deep: true,
        },
    },
    data() {
        return {
            selected: null,
        };
    },
    mounted() {
        if (this.question_directions && this.question_directions.length === 0)
            this.updateInventory();
    },
    computed: {
        ...mapGetters({
            question_directions: "questionDirectionList/inventory",
            mode:'MODE'
        }),
    },
    methods: {
        ...mapActions({
            updateInventory: "questionDirectionList/inventory",
        }),
        dispatch(e) {
            this.$emit("input", e);
            this.selected = e;
        },
    },
};
</script>
